import React from "react";
import { Box } from "@chakra-ui/react";

const Tag = (props: { label: string }) => {
  return (
    <Box
      borderRadius="30px"
      backgroundColor="#EBF0FF"
      paddingX="20px"
      paddingY="10px"
      fontWeight="500"
      width="fit-content"
      color={"#0F2463"}
      fontSize="large"
    >
      {props.label}
    </Box>
  );
};

export default Tag;
